export const mapClientUserList = (arr) =>
  arr.map((item) => ({
    id: item.id,
    label: item.full_name,
    value: item.full_name,
  }));
